export enum ProofType {
  GovernmentDocument = 'government_document',
  OtherDocument = 'other_document',
}
